const APP_IMAGES = {
  joinUsbBg: require("./images/auth-bg-img.png"),
  authBgImg: require("./images/auth-bg.png"),
  uploadImage: require("./images/upload-image.png"),
  noImageAvailable: require("./images/image-not-found.png"),
};

const APP_ICONS = {
  dashboardWhiteIcon: require("./icons/dashboard-white-icon.png"),
  dashboardBlackIcon: require("./icons/dashboard-black-icon.png"),
  smileWhiteIcon: require("./icons/smiley-white-icon.png"),
  smileBlackIcon: require("./icons/smiley-black-icon.png"),
  bookWhiteIcon: require("./icons/book-white-icon.png"),
  bookBlackIcon: require("./icons/book-black-icon.png"),
  bagWhiteIcon: require("./icons/bag-white-icon.png"),
  bagBlackIcon: require("./icons/bag-black-icon.png"),
  cartWhiteIcon: require("./icons/cart-white-icon.png"),
  cartBlackIcon: require("./icons/cart-black-icon.png"),
  handshakeWhiteIcon: require("./icons/handshake-white-icon.png"),
  handshakeBlackIcon: require("./icons/handshake-black-icon.png"),
  notificationWhiteIcon: require("./icons/notification-white-icon.png"),
  notificationBlackIcon: require("./icons/notification-black-icon.png"),
  notificationPurpleIcon: require("./icons/notification-purple-icon.png"),
  reportWhiteIcon: require("./icons/report-white-icon.png"),
  reportBlackIcon: require("./icons/report-black-icon.png"),
  packageWhiteIcon: require("./icons/package-white-icon.png"),
  packageBlackIcon: require("./icons/package-black-icon.png"),
  settingWhiteIcon: require("./icons/settings-white-icon.png"),
  settingBlackIcon: require("./icons/settings-black-icon.png"),
  settingPurpleIcon: require("./icons/setting-purple-icon.png"),
  calendarWhiteIcon: require("./icons/calendar-white-icon.png"),
  calendarBlackIcon: require("./icons/calendar-check-icon.png"),
  fourArrowIcon: require("./icons/four-arrow-icon.png"),
  questionPurpleIcon: require("./icons/question-purple-icon.png"),
  logoutPurpleIcon: require("./icons/logout-pruple-icon.png"),
  searchGreyIcon: require("./icons/search-grey-icon.png"),
  exportBlockIcon: require("./icons/export-black-icon.png"),
  deleteRedIcon: require("./icons/delete-red-icon.png"),
  editMustardIcon: require("./icons/edit-mustard-icon.png"),
  backPurpleIcon: require("./icons/back-purple-icon.png"),
  squareGreyIcon: require("./icons/square-grey-icon.png"),
  squareCheckGreenIcon: require("./icons/square-check-green-icon.png"),
  sendIcon: require("./icons/send-icon.png"),
  donationBlackIcon: require("./icons/donation-black.png"),
  donationWhiteIcon: require("./icons/donation-white.png"),
};

const appLogo = {
  mainLogo: require("./icons/Group 1000004517.png"),
  eazidayLogo: require("./images/service-provider-logo-new.png"),
};

const appFonts = {
  Roboto: "Roboto",
  Poppins: "Poppins",
};

const appGifs = {
  blueLoading: require("./gifs/blue-loading.gif"),

};
export { APP_IMAGES, APP_ICONS, appLogo, appFonts, appGifs };
